import { FC, PropsWithChildren } from 'react'

import styled from 'styled-components'

export type SimpleLabelProps = PropsWithChildren & {
  className?: string
  color?: 'green' | 'grey' | 'red'
}

const getTextColor = (color?: 'green' | 'grey' | 'red'): string => {
  switch (color) {
    case 'green':
      return '#12A044'
    case 'red':
      return '#EC1E1E'
    case 'grey':
    default:
      return '#333'
  }
}

const getBackgroundColor = (color?: 'green' | 'grey' | 'red'): string => {
  switch (color) {
    case 'green':
      return '#D3F8E0'
    case 'red':
      return '#FFDADA'
    case 'grey':
    default:
      return '#E7E7E7'
  }
}

const Container = styled.div<SimpleLabelProps>`
  font-family: 'Segoe UI', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
  border-radius: 16px;
  text-align: center;
  display: inline-flex;
  padding: 3px 6px;
  align-items: center;
  justify-content: center;
  color: ${({ color }) => getTextColor(color)};
  background-color: ${({ color }) => getBackgroundColor(color)};
`

export const SimpleLabel: FC<SimpleLabelProps> = ({
  children,
  className,
  color = 'grey',
}) => (
  <Container className={className} color={color}>
    {children}
  </Container>
)
